/**
 * Жест на кнопке микрофона — чистый автомат без DOM, чтобы проверять отдельно.
 * Повторяет ГиперЧАТ (packages/chat-ui/src/components/Composer.tsx, micDown ~251–280):
 *  • короткое нажатие (меньше 350 мс) — запись «закреплена», идёт, пока не нажмут «стоп»;
 *  • удержание — запись, пока палец не отпущен;
 *  • свайп вверх больше чем на 40 px — закрепить запись и отпустить палец.
 */
export const TAP_MS = 350;
export const LOCK_SWIPE_PX = 40;

export type GesturePhase = 'idle' | 'holding' | 'locked';

export interface Gesture {
  phase: GesturePhase;
  /** Когда нажали (мс) и где (clientY). */
  at: number;
  y: number;
}

export const idleGesture: Gesture = { phase: 'idle', at: 0, y: 0 };

/** Палец лёг на микрофон. */
export function press(now: number, y: number): Gesture {
  return { phase: 'holding', at: now, y };
}

/** Палец двигается: достаточно высоко вверх — запись закрепляется. */
export function move(g: Gesture, y: number): Gesture {
  if (g.phase !== 'holding') return g;
  return g.y - y > LOCK_SWIPE_PX ? { ...g, phase: 'locked' } : g;
}

export type ReleaseAction = 'none' | 'lock' | 'stop';

/**
 * Палец отпущен.
 *  • закреплённая запись отпусканием не кончается;
 *  • короткое нажатие закрепляет запись (иначе «нажал и сразу стоп» = пустая запись);
 *  • долгое удержание — стоп, запись готова.
 */
export function release(g: Gesture, now: number): { gesture: Gesture; action: ReleaseAction } {
  if (g.phase === 'locked') return { gesture: g, action: 'none' };
  if (g.phase !== 'holding') return { gesture: g, action: 'none' };
  if (now - g.at < TAP_MS) return { gesture: { ...g, phase: 'locked' }, action: 'lock' };
  return { gesture: idleGesture, action: 'stop' };
}

/** Запись отменена или закончилась — жест сброшен. */
export const reset = (): Gesture => idleGesture;
